import { render } from "./PosterProjects.vue?vue&type=template&id=3a63c2f6"
import script from "./PosterProjects.vue?vue&type=script&lang=js"
export * from "./PosterProjects.vue?vue&type=script&lang=js"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__